<script lang="ts" setup>
import { ref, defineEmits } from "vue";

import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";

const emit = defineEmits(["back", "cancel"]);

const onCancel = () => {
  emit("cancel");
};

const onBack = () => {
  emit("back");
};
</script>

<template>
  <div class="container">
    <div>
      <h1 class="header-text">キャンセル方法</h1>
    </div>
    <img
      src="@/assets/img/applicationReminder/HowToCancel.png"
      alt="キャンセル方法"
      class="image"
    />
    <div>
      <h1 class="header-text">信用スコアの減点ルール</h1>
      <p>事業所に連絡したタイミングで減点</p>
    </div>
    <div>
      <img
        src="@/assets/svg/credit_score_rules.svg"
        alt="信用スコアの減点ルール"
        class="image"
      />
      <p class="subtraction-rules-text">
        信用スコアが0ptになると応募済のお仕事も全てキャンセルとなり、一時的にお仕事へ応募不可になります
      </p>
    </div>
    <div class="d-flex flex-column">
      <AppButton @click="onCancel" class="mb-2" data-testid="proceed-cancel"
        >お仕事のキャンセルに進む</AppButton
      >
      <AppButtonOutline @click="onBack" variant="primary"
        >戻る</AppButtonOutline
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.header-text {
  font-size: 18px;
  font-weight: 600;
}

.image {
  width: 100%;
}

.subtraction-rules-text {
  color: #c2493e;
}
</style>
